import { ChangeDetectionStrategy, Component } from "@angular/core";
import { AnimationOptions } from "ngx-lottie";
import { SwapSuccessComponent } from "@modules/main/components/step-summary/success-screens/swap-success/swap-success.component";
import { SharePreviewComponent } from "@modules/social-trading/components/share-preview/share-preview.component";
import { TRADE_TYPE } from "@models/trade-offer.model";
import { TRADE_LOCAKEY } from "@modules/social-trading/components/share-preview/share-preview.constants";

@Component({
	selector: "swap-success-v1",
	templateUrl: "./swap-success-redesign.component.html",
	styleUrls: ["./../../success-screen.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class SwapSuccessV1Component extends SwapSuccessComponent {
	public successAnimationOptions: AnimationOptions = {
		path: "assets/animations/trade_success_animation.json",
		loop: false
	};

	public shareTrade(): void {
		const sourceAssetId = this.swapSuccessTrades[0].getCurrencyId();
		const targetAssetId = this.swapSuccessTrades[1].getCurrencyId();
		const tradeType = TRADE_TYPE.SWAP;
		this.modalService
			.create(SharePreviewComponent, {
				assetId: targetAssetId,
				tradeType,
				sourceAssetId: sourceAssetId,
				locaKey: TRADE_LOCAKEY
			})
			.present();
	}
}
